import type { ButtonHTMLAttributes } from 'react';
import { cn } from '@/shared/helpers/cn';
import styles from './ToggleChip.module.scss';

export interface ToggleChipProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'children'> {
  label: string;
  /** Ligado, o chip fica preenchido e `aria-pressed` anuncia o estado. */
  pressed: boolean;
}

/**
 * Chip de filtro que liga e desliga.
 *
 * Para recortar uma listagem por valores que cabem na tela — os tipos de ficha
 * do prontuário, por exemplo. Vários podem ficar ligados ao mesmo tempo, e o
 * mesmo clique que liga é o que desliga: é assim que se tira um filtro sem
 * procurar um botão de limpar.
 *
 * É `button[aria-pressed]`, não caixa de seleção: o chip **age na hora** sobre
 * o que a tela mostra, enquanto a caixa de seleção junta escolhas para um envio
 * posterior. O estado não é comunicado só pela cor — o leitor de tela anuncia
 * "pressionado", e o preenchimento vem com peso de fonte maior.
 */
export function ToggleChip({ label, pressed, className, ...rest }: ToggleChipProps) {
  return (
    <button
      type="button"
      aria-pressed={pressed}
      className={cn(styles.chip, pressed && styles.pressionado, className)}
      {...rest}
    >
      {label}
    </button>
  );
}
